// extracted by mini-css-extract-plugin
export default {"empty":"Report_empty__HRh-F","placeHolderShimmer":"Report_placeHolderShimmer__Gesgc"};